import { isCountryUSA } from "@faire/deprecated-retailer-visitor-shared/lib/countryUtils";
import { useSignUpEventTracker } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_hooks/useSignUpEventTracker";
import {
  GlobalResellerCertFields,
  useGlobalSchema,
} from "@faire/deprecated-retailer-visitor-shared/views/SignUp/reseller-cert/__internal__/GlobalResellerCertFields";
import {
  USAResellerCertFields,
  useUSASchema,
} from "@faire/deprecated-retailer-visitor-shared/views/SignUp/reseller-cert/__internal__/USAResellerCertFields";
import { Step } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/Step";
import { IBusinessIdentifier } from "@faire/web-api--source/indigofair/idv/IBusinessIdentifier";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { useFormikContext } from "formik";
import { Form } from "formik";
import React, { useMemo } from "react";

export type ResellerCertData = {
  certificate_number: string | undefined;
  expires_at: string | undefined;
  signing_name: string | undefined;
  state: string | undefined;
  ein: string | undefined;
  ssn: string | undefined;
  drivers_license_number: string | undefined;
  google_place_id: string | undefined;
  legal_business_name: string | undefined;
  business_identifier: IBusinessIdentifier | undefined;
};

export const ResellerCertForm: React.FC<{
  loading: boolean;
  country: string | undefined;
}> = ({ loading, country }) => {
  const { trackFieldValue } = useSignUpEventTracker(Step.RESELLER_CERT);
  const { isValid } = useFormikContext<ResellerCertData>();

  return (
    <Form>
      <Column>
        {isCountryUSA(country) ? (
          <USAResellerCertFields trackFieldValue={trackFieldValue} />
        ) : (
          <GlobalResellerCertFields
            country={country}
            trackFieldValue={trackFieldValue}
          />
        )}
        <Spacer height="7x" />
        <Button
          type="submit"
          data-test-id="next"
          disabled={!isValid}
          loading={loading}
        >
          <StrictLocalMsg
            id="m853T8"
            defaultMessage="Next"
            description={{ text: "Button to visit the next page" }}
          />
        </Button>
      </Column>
    </Form>
  );
};

export const useSchema = (country: string | undefined) => {
  const usaSchema = useUSASchema();
  const globalSchema = useGlobalSchema();

  return useMemo(
    // currently, global don't have any validation
    () => (isCountryUSA(country) ? usaSchema : globalSchema),
    [country, globalSchema, usaSchema]
  );
};
